<app-service-layout-v2
  [serviceParams]="{
            game: 'apex',
            service: 'placements',
            type: 'solo',
            title: 'Provisionals',
            subtitle: 'Get a season head start with an average Top 2 Provisionals',
            start: 13,
            desired: 10,
            serviceName: 'Matches',
            min: 1,
            max: 10
        }"
  [serviceFaqs]='[
            {
                question: "What Is A Provisional Boosting Service?",
                answer: "Provisional boost is a type of boosting that guarantees you get an average of second place in your 10 provisional matches. For less than 10 provisional matches, a different result may apply."
            },
            {
                question: "What If I Dont Get At Least An Average Of Second Place?",
                answer: "In case we go below our guaranteed minimum we will grant you a compensation in the form of free Ranking Points. The number of Ranking Points awarded depends on the final result."
            },
            {
                question: "I Already Played One Or More Provisionals, Can I Still Buy This?",
                answer: "Yes, you can. Simply select your past season rank and the number of remaining provisional matches from the banner above."
            },
            {
                question: "Can I Play With The Booster In Duo Queue Boosting?",
                answer: "Yes, you can. To make it happen, click on the \"DUO\" red button in the order additions menu."
            },
            {
                question: "Can I Choose My Preferred Legends?",
                answer: "Yes, you can. To make it happen click on the \"Choose your Agents\" button in the order additions menu."
            },
            {
                question: "Can I Play While The Order Is Active?",
                answer: "Yes, unless you want to queue in rank. Other than that, simply schedule it in the order chat with your booster."
            },
            {
                question: "Can I Request The Same Booster For A Future Purchase?",
                answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
            },
            {
			    question: "I Was Ranked Last Season, How Many Provisionals Matches Do I Need?",
                answer: "On new seasons you always need 10 Provisional Matches."
            },
            {
              question: "What If I Have More Questions?",
              answer: "We have a FAQ and dedicated Live Support Team, online 24 hours per day, always ready to help you through every step and ready to answer all your questions!"
            }
        ]'
  [currentServiceIcon]="'https://cdn.ggboost.com/images/apex/services/provisionals.webp'"
  [availableServices]="availableServices"
></app-service-layout-v2>
